<template>
    <div>
        <z-title title="预定提醒" ref="title"></z-title>
        <el-row :gutter="20">
            <el-col :span="17">
                <z-calendar1 ref="search" name="预定" :imp-list="impList" @add="addOrder" @getDate="getDate" @getDateRange="getDateRange"></z-calendar1>
                <el-card >
                    <el-table
                            v-loading="loading"
                            :height="height+'px'"
                            highlight-current-row
                            element-loading-text="列表刷新中"
                            element-loading-spinner="el-icon-loading"
                            header-cell-class-name="headerrow"
                            cell-class-name="cellclass"
                            :data="dataList"
                            style="width: 100%">
                        <el-table-column
                                fixed
                                align="center"
                                prop="customName"
                                label="客户姓名"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                label="订单状态"
                                min-width="100"
                                align="center">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='04'"  type="warning">{{scope.row.confirmStateText}}</el-tag>
                                <el-tag size="mini" effect="plain"  v-if="scope.row.confirmState=='03'" type="info">{{scope.row.confirmStateText}}</el-tag>
                                <el-tag size="mini" effect="plain"  v-if="scope.row.confirmState=='02'" type="danger">{{scope.row.confirmStateText}}</el-tag>
                                <el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='01'" type="success">{{scope.row.confirmStateText}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="phone"
                                label="电话"
                                width="120"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="orderDateRange"
                                label="预定日期"
                                width="200"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="houseName"
                                label="预定场地"
                                width="120"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="orderStateText"
                                label="预定状态"
                                min-width="100"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="100"
                                align="center">
                            <template slot-scope="scope">
                                <el-button  v-if="Date.now()<new Date(scope.row.beginTime).getTime()&&scope.row.confirmState!='01'&&scope.row.confirmState!='02'" type="text" size="small" @click="gotoHandle(scope.row.orderId,true,scope.row.orderDateRange)">处理</el-button>
                                <el-button v-else  type="text" size="small" @click="gotoHandle(scope.row.orderId,false)">查看处理</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页-->
                    <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                                @currentChange="handleCurrentChange"></pagination>
                </el-card>
            </el-col>
            <el-col :span="7">
                <z-dateselect title="预定" @getDaterange="getOrderAnalysis"></z-dateselect>
                <z-little-card title="预定总单数" :num="askAnalysis.orderTotalCount" subtitle="日均单数" :subnum="askAnalysis.orderAvgDay" subtitle2="当日订单" :subnum2="askAnalysis.orderDayCount" icon="icon-icon"></z-little-card>
                <z-little-card title="待确认单数" :num="askAnalysis.orderToCheckCount" icon="icon-shenhe"></z-little-card>
                <z-little-card title="待结算订单数" :num="askAnalysis.orderUnfinishedCount" icon="icon-icon_"></z-little-card>
                <z-little-card title="待确认占比（待确认➗全部预定数）" :num="askAnalysis.orderCheckRate+'%'" icon="icon-icon_A"></z-little-card>
                <z-little-card title="待结算占比（已完成➗全部预定数）" :num="askAnalysis.orderFinishedRate+'%'" icon="icon-icon_A-copy-copy-copy"></z-little-card>
            </el-col>
        </el-row>
        <!--处理-->
        <el-dialog :visible.sync="showhandle" v-loading="addloading" element-loading-text="保存中……" class="doconsult " width="880px"  :close-on-click-modal="false">
            <div slot="title">
                <z-title title="处理咨询"></z-title>
            </div>
            <el-form :model="dataForm" class="plr-20" size="medium" :rules="handlerule" label-width="110px"  ref="dataForm">
               <template  v-if="showzixun">
                <el-form-item label="下次提醒日期" :show-message="false" prop="alertDate" :rules="checkedAlert?[]:[{required: true, trigger: 'change'}]">
                    <el-date-picker
                            v-model="dataForm.alertDate"
                            value-format="yyyy-MM-dd"
                            type="date"
                            :disabled="checkedAlert"
                            :picker-options="pickerOptions"
                            placeholder="请选择下次提醒日期">
                    </el-date-picker>
                    <el-checkbox class="ml-10" v-model="checkedAlert">不提醒</el-checkbox>
                </el-form-item>
                <el-form-item label="备 注" prop="remark" :rules="checkedAlert?[]:[{required: true, message: '备注不能为空', trigger: 'change'}]">
                    <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                              maxlength="512"></el-input>
                </el-form-item>
               </template>
                <div class="ptb-10 el-icon-s-data"> 处理记录</div>
                <el-table
                        header-cell-class-name="headerrow"
                        cell-class-name="cellclass"
                        :data="handleData"
                        style="width: 100%">
                    <el-table-column
                            align="center"
                            prop="remark"
                            label="备注"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            prop="createTime"
                            label="沟通日期"
                            min-width="120"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            prop="updateUserName"
                            label="经办人"
                            width="100"
                            align="center">
                    </el-table-column>
                </el-table>
                <el-form-item class="mt-10 flex-n fje ">
                    <el-button type="primary" @click="saveHandle('dataForm')">保 存</el-button>
                    <el-button @click="showhandle = false">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--预定-->
        <books  :visible.sync="showreserve" ref="books"  type="新增" @refresh="refreshList"></books>

    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import ZCalendar1 from "../../components/ZCalendar1";
    import ZLittleCard from "../../components/ZLittleCard";
    import ZDateselect from "../../components/ZDateselect";
    import ElForm from "element-ui/packages/form/src/form";
    import Books from "../component/books";
    import ElCard from "element-ui/packages/card/src/main";
    import Pagination from "../../components/pagination/pagination";

    export default {
        components: {
            Pagination,
            ElCard,
            Books,
            ElForm,
            ZDateselect,
            ZLittleCard,
            ZCalendar1,
            ZTitle},
        name: "remind",
        data() {
            return {
                addloading:false,
                loading: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height: 250,
                checkedAlert:true,
                orderId:'',
                handleData:[],
                showhandle:false,//处理页
                showzixun:true,
                timearea:[],
                orderDate:'',
                //处理咨询
                dataForm:{
                    alertDate:'',
                    remark:''
                },
                handlerule:{ },
                askAnalysis:{
                    "orderTotalCount": "2523",
                    "orderAvgDay": "66",
                    "orderDayCount": "46",
                    "orderToCheckCount": "523",
                    "orderUnfinishedCount": "63",
                    "orderFinishedRate": "95",
                    "orderCheckRate":"76"
                },
                dataList:[],
                //预定数据
                dataForm2:{
                    name:'',//姓名
                    tel:'',//电话
                    booksdate:'',//预定日期
                    startTime:'',//时间段开始
                    endTime:'',//时间段结束
                    intentpart:'',//预定场地
                    intenttype:'',//预定类型
                    payway:'1',//收费方式
                    everyprice:0,//每人价格
                    booksnum:0,//预定人数
                    everytable:0,//每桌价格
                    bookstables:0,//预定桌数
                    sparetables:0,//备用桌数
                    packageprice:0,//包场价格
                    booksmeals:'',//预定套餐
                    booksunitprice:'',//预定单价
                    additemprice:'',//添加项目合计金额
                    handsel:'',//已收定金
                    reminddate:'',//提醒日期
                    totalprice:0.00,//总计应收
                    bookstate:'1',//预定状态
                    comefrom:'',//顾客来源
                    remarks:''//备注
                },
                showreserve:false,
                impList:[]
            }
        },
        watch: {
            showhandle(newval, oldval) {
                if (!newval) {
                    this.$refs.dataForm.resetFields();
                    this.checkedAlert=true;
                }
            },
            checkedAlert(newval, oldval) {
               if(newval){
                   this.dataForm.alertDate="";
               }
            },
        },
        mounted(){
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 190;
                console.log(this.height)
            },0)  
        },
        computed: {
            pickerOptions() {
                return {
                    disabledDate: time => (this.orderDate == null ? (time.getTime() < Date.now() - 24 * 60 * 60 * 1000) : (time.getTime() > new Date(this.orderDate).getTime() || time.getTime() < Date.now() - 24 * 60 * 60 * 1000))
                }
                //只能选今天之后的
            },
        },
        methods: {
            //刷新列表
            refreshList(){
                this.currentPage=1;
                this.getorderList();
                this.getDateRange(this.timearea);
            },
            //预定提醒表头(上)
            getDateRange(date){
                this.timearea=date;
                this.$axios.post('/order/orderAlertHeader',{
                    "startTime":date[0].date,
                    "endTime": date[6].date,
                    "storeId": this.$root.getStorage('storeId'),
                }).then(res=>{
                    console.log('预定提醒表头',res)
                    this.impList=[].concat(res.data.list);
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //获取日期区间根据区间查询预定分析数据（右）
            getOrderAnalysis(data){
                this.$axios.post('/order/reportOrderAnalysis',{
                    "storeId": this.$root.getStorage('storeId'),
                    "startTime":data[0],
                    "endTime": data[1]
                }).then(res=>{
                    console.log('预定分析数据',res)
                    this.askAnalysis=res.data;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //获取当前日期
            getDate(date){
                this.alertDate=date.date;
                console.log(date.date)
                this.currentPage=1;
                this.getorderList();
            },
            //当前待处理预定数据
            getorderList() {
                this.loading=true;
                this.$axios.post('/order/orderAlertByDate', {
                    "storeId": this.$root.getStorage('storeId'),
                     "alertDate": this.alertDate,
                    "currentPage":this.currentPage,
                    "pageSize":this.pageSize,
                }).then(res => {
                    console.log( this.alertDate,'数据列表',res.data)
                    this.dataList = res.data.list;
                    this.total=res.data.total;
                    this.loading=false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading=false;
                })
            },

            gotoHandle(orderId,state,orderDate=null){
                this.orderId=orderId;
                this.showzixun=state;
                this.showhandle=true;
                if(orderDate!=null){
                    orderDate=orderDate.substring(0,orderDate.indexOf(' '));
                }
                this.orderDate=orderDate;
                this.getHandleRecord(orderId);
            },
            getHandleRecord(orderId){
                //显示10个
                this.$axios.get('/order/orderDetailById/'+orderId).then(res => {
                    console.log('处理记录',res.data.orderFollowList)
                    this.handleData = res.data.orderFollowList;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },

            addOrder(){
                    this.showreserve=true;
            },
            saveHandle(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addloading=true;
                        this.$axios.post('/order/orderFollowAdd',{
                            "orderId": this.orderId,
                            "alertDate": this.dataForm.alertDate,
                            "remark": this.dataForm.remark
                        }).then(res=>{
                            this.addloading=false;
                            this.$message.success('处理咨询成功！');
                            this.showhandle = false;
                            this.getorderList();
                            this.getDateRange(this.timearea);
                        }).catch(err=>{
                            this.addloading=false;
                            this.$message.error(err.msg);
                        })
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.getorderList();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage=val;
                this.getorderList();
                console.log(`当前页: ${val}`);
            },
        },
    }
</script>

<style scoped lang="scss">
    .pagination{
        height: 50px;
        background: #f2f2f2;
    }
</style>